export default __webpack_public_path__ + "static/media/annex2.baa6a7fa.png";